// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SLi1a","content":"styles_content__RtZ2g"};